export const routes = [
  {
    path: '/sell/',
    name: 'sellHome',
    // No newAppPath: Vue Router resolves this redirect before the newAppRouting mixin's $route
    // watcher sees it, so /sell/ reaches the NextGen pipeline through the pipeline route.
    redirect: '/sell/pipeline',
  },
  {
    path: '/sell/pipeline',
    name: 'pipeline',
    meta: { newAppPath: '/exchange/pipeline' },
    component: () => import('../components/PipelineGrid/PipelineGrid.vue'),
  },
  {
    path: '/sell/uploads',
    name: 'uploads',
    meta: { newAppPath: '/exchange/uploads' },
    component: () => import('../pages/LoanUploadPage.vue'),
  },
  {
    path: '/sell/loan/:id',
    name: 'loanDetails',
    props: true,
    meta: { newAppPath: '/exchange/loan/:id' },
    component: () => import('../components/LoanDetails/SellLoanDetails.vue'),
  },
  {
    path: '/sell/committed_loans',
    name: 'committedLoans',
    meta: {
      breadcrumbsText: 'Committed Loans',
      newAppPath: '/exchange/committed-loans',
    },
    component: () => import('../components/CommittedLoans.vue'),
  },
  {
    path: '/sell/loan_manager',
    name: 'loanManager',
    meta: { newAppPath: '/exchange/loan-manager' },
    component: () => import('../pages/LoanManagerPage.vue'),
  },
  {
    path: '/sell/import_issues',
    name: 'importIssues',
    meta: { newAppPath: '/exchange/import-issues' },
    component: () => import('../pages/ImportIssuesPage.vue'),
  },
  {
    path: '/sell/committed_pools',
    name: 'committedPools',
    meta: {
      breadcrumbsText: 'Committed Pools',
      newAppPath: '/exchange/committed-pools',
    },
    component: () => import('../pages/CommitmentPoolPage/CommittedPools.vue'),
  },
  {
    path: '/sell/committed_pools/add',
    name: 'newCommittedPool',
    props: true,
    // NextGen has no create route — recording a commitment is a modal on the list page — so this
    // lands on the list, where that modal is one button away.
    meta: { newAppPath: '/exchange/committed-pools' },
    component: () => import('../pages/CommitmentPoolDetailPage.vue'),
  },
  {
    path: '/sell/committed_pools/:poolId',
    name: 'editCommittedPool',
    props: true,
    // NextGen shows the pool read-only with an Edit button opening the record-commitment modal,
    // rather than the edit form this Classic route renders.
    meta: { newAppPath: '/exchange/committed-pools/:poolId' },
    component: () => import('../pages/CommitmentPoolDetailPage.vue'),
  },
  {
    path: '/sell/commitment_cart',
    name: 'commitmentCart',
    meta: {
      breadcrumbsText: 'Commitment Cart',
      newAppPath: '/exchange/commitment-cart',
    },
    component: () => import('../components/CommitmentCart/CommitmentCart.vue'),
  },
];
